<div class="create-playlist layout-spacing">
    <div>
        <h1 data-testid="create-playlist-title" class="create-playlist__title">
            Playlist Information
        </h1>
        <p data-testid="create-playlist-description" class="create-playlist__description">
            Add a new playlist to organize and manage your media contents
        </p>
    </div>

    <div class="create-playlist__stepper">
        <ntv-stepper
            [steps]="playlistSteps"
            size="md"
            [currentStep]="currentStepId()"
            [clickable]="true"
            (stepClick)="handleStepClick($event)"></ntv-stepper>
    </div>

    <div class="create-playlist__steps-content">
        @if (currentStepId() === 0) {
            <app-fill-information></app-fill-information>
        }

        @if (currentStepId() === 1) {
            <app-select-assets-step></app-select-assets-step>
        }

        @if (currentStepId() === 2) {
            <app-settings></app-settings>
        }
    </div>
    <div class="create-playlist__navigation">
        <ntv-button size="xl" (buttonClick)="prevStep()"
            ><span class="btn-span--md">Previous</span></ntv-button
        >
        <ntv-button
            size="xl"
            variant="accent"
            (buttonClick)="nextStep()"
            [disabled]="!isStepValid() || isSubmitting()"
            [loading]="isSubmitting()"
            ><span class="btn-span--xl">{{
                currentStepId() === playlistSteps.length - 1 ? 'Create Playlist' : 'Next'
            }}</span></ntv-button
        >
    </div>
</div>

<!-- Success or Error modal for creating playlist -->
@if (showConfirmationModal()) {
    <app-confirmation-modal
        [isVisible]="showConfirmationModal()"
        [type]="modalConfig().type"
        [loopAnimation]="false"
        [title]="modalConfig().title"
        [message]="modalConfig().message"
        [confirmText]="isPlaylistCreated() ? 'Go to Playlists' : 'Try Again'"
        (confirm)="onModalClose()"
        (modalClose)="onModalClose()"></app-confirmation-modal>
}
